import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
  message: "",
  variant: "success",
  otherProps: {},
};

const messageBarSlice = createSlice({
  name: "messageBar",
  initialState,
  reducers: {
    // Show message bar
    showMessageBar: (state, action) => {
      const { message, variant = "success", otherProps = {} } = action.payload;
      state.open = true;
      state.message = message;
      state.variant = variant;
      state.otherProps = otherProps;
    },

    // Hide message bar
    hideMessageBar: (state) => {
      state.open = false;
    },

    // Set full state (used for syncing from index.js)
    setMessageBar: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { showMessageBar, hideMessageBar, setMessageBar } =
  messageBarSlice.actions;
export default messageBarSlice.reducer;
